import { makeApolloClient, logError } from '../util';
import { ANNOUNCEMENTS } from 'queries/announcement';

export const FETCH_ANNOUNCEMENTS = 'FETCH_ANNOUNCEMENTS';
export const CLEAR_ANNOUNCEMENTS = 'CLEAR_ANNOUNCEMENTS';
export const CREATE_ANNOUNCEMENT = 'CREATE_ANNOUNCEMENT';
export const SEND_ANNOUNCEMENT = 'SEND_ANNOUNCEMENT';
export const UPDATE_ANNOUNCEMENT = 'UPDATE_ANNOUNCEMENT';
export const DELETE_ANNOUNCEMENT = 'DELETE_ANNOUNCEMENT';
export const ADD_GROUPS_TO_ANNOUNCEMENT = 'ADD_GROUPS_TO_ANNOUNCEMENT';
export const REMOVE_GROUPS_FROM_ANNOUNCEMENT = 'REMOVE_GROUPS_FROM_ANNOUNCEMENT';

const fetchAnnouncements = (announcements, from) => ({
	type: FETCH_ANNOUNCEMENTS,
	announcements,
	from,
});

export const createAnnouncement = (announcement, from) => ({
	type: CREATE_ANNOUNCEMENT,
	announcement,
	from,
});

export const sendAnnouncement = (announcement, from) => ({
	type: SEND_ANNOUNCEMENT,
	announcement,
	from,
});

export const updateAnnouncement = (announcement, from) => ({
	type: UPDATE_ANNOUNCEMENT,
	announcement,
	from,
});

export const deleteAnnouncement = (announcementID, from) => ({
	type: DELETE_ANNOUNCEMENT,
	announcementID,
	from,
});

export const addGroupsToAnnouncement = ({ groupIDs, announcementID }, from) => ({
	type: ADD_GROUPS_TO_ANNOUNCEMENT,
	groupIDs,
	announcementID,
	from,
});

export const removeGroupsFromAnnouncement = ({ groupIDs, announcementID }, from) => ({
	type: REMOVE_GROUPS_FROM_ANNOUNCEMENT,
	groupIDs,
	announcementID,
	from,
});

export const clearAnnouncements = from => ({
	type: CLEAR_ANNOUNCEMENTS,
});

export const thunkFetchAnnouncements = ({ event_id, offset, items_per_page }, from) => async (
	disptach,
	getState
) => {
	const client = makeApolloClient(getState());
	try {
		const { announcements } = await client.request(ANNOUNCEMENTS, {
			event_id,
			offset,
			items_per_page,
		});
		disptach(fetchAnnouncements(announcements, from));
	} catch (error) {
		logError(error, 'announcements.actions.thunkFetchAnnouncements');
	}
};
